import { useContext, useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { SupportUserQuery } from 'interfaceAdapter/queries/SupportUser';
import { supportUserContext } from 'application/contexts/useSupportUser';

/**
 * 認証状態の確認と、ログイン後ページの共通処理
 */
export const useSupportStandard = () => {
    const mainRef = useRef<HTMLDivElement>(null);
    const navigate = useNavigate();
    const diContainer = useContext(diContainerContext);
    const supportUserQuery = diContainer.resolve(SupportUserQuery);
    const { setUser } = useContext(supportUserContext);
    const [canEnter, setCanEnter] = useState(false);
    const [isSideOpen, setIsSideOpen] = useState(true);

    useEffect(() => {
        if (mainRef.current) {
            mainRef.current.scrollTop = 0;
        }
        const checkCanEnter = async () => {
            const { user, status } = await supportUserQuery.checkToken(false);
            if (status !== false) {
                setUser(user);
                setCanEnter(true);
            } else {
                // 有効なトークンが無いのでリダイレクト
                navigate('/supporter/login/');
            }
        };
        checkCanEnter();
    }, [window.location]);

    return { mainRef, canEnter, isSideOpen, setIsSideOpen };
};
